// extracted by mini-css-extract-plugin
module.exports = {"loanWrapper":"_1QCVx","loanDocLabel":"_1ILUR","loaderPopup":"_1UInj","documentWrapper":"E5-Be","pendingAmountWrapper":"_1p_IP","disabledToggle":"_3X01Y","cibilCtaWrapper":"_1DT1y"};